module.exports = __webpack_public_path__ + "static/26-d73ebe430185209cc6bc99daa4471f21.jpg";